import * as z from "zod/v4";

export const partnerStatusSchema = z.enum(["active", "paused", "terminated"]);
export type PartnerStatus = z.infer<typeof partnerStatusSchema>;

export const partnerTypeSchema = z.enum(["individual", "app", "agency"]);
export type PartnerType = z.infer<typeof partnerTypeSchema>;

/**
 * Shape returned by list-partners and used as the row type in tables.
 */
export const partnerSummarySchema = z.object({
  id: z.string(),
  email: z.string(),
  name: z.string(),
  referralCode: z.string(),
  partnerType: partnerTypeSchema,
  status: partnerStatusSchema,
  createdBy: z.string(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type PartnerSummary = z.infer<typeof partnerSummarySchema>;

/**
 * Auth-event row included in partner detail views. Free-form `eventType`
 * because new types may be added (admin-side audits, social-login, etc.)
 * without forcing a schema bump on every consumer.
 */
export const partnerAuthEventSchema = z.object({
  id: z.string(),
  partnerId: z.string().nullable(),
  email: z.string().nullable(),
  eventType: z.string(),
  ipAddress: z.string().nullable(),
  userAgent: z.string().nullable(),
  magicLinkJti: z.string().nullable(),
  occurredAt: z.string(),
});
export type PartnerAuthEvent = z.infer<typeof partnerAuthEventSchema>;

/**
 * Shape returned by get-partner. Includes the most-recent auth events
 * so the detail page can render them inline without a follow-up RPC.
 */
export const partnerDetailSchema = partnerSummarySchema.extend({
  recentAuthEvents: z.array(partnerAuthEventSchema),
});
export type PartnerDetail = z.infer<typeof partnerDetailSchema>;
